import styled from '@emotion/styled'
import { StyledHeader } from 'components/feature/node.style'

export const StyledQueryHeader = styled(StyledHeader)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    width: 238px;
    margin-right: 0;
  }
`
